import PropTypes from "prop-types";
import { AvatarsButton } from "./AvatarsButton";

export const PostSpaceActions = ({ space }) => <AvatarsButton space={space} />;

PostSpaceActions.propTypes = {
  space: PropTypes.object.isRequired,
};
